// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pricing_wrapper__XL8MR","container":"Pricing_container__3QUFO","versionsContainer":"Pricing_versionsContainer__3aUK9"};